// Sidebar navigation labels. Sections + item names, keyed by AdminLayout.
export const nav = {
  sections: {
    myDay: "My Day",
    inbox: "Inbox",
    sales: "Sales",
    operations: "Operations",
    finance: "Finance",
    content: "Content",
    marketing: "Marketing",
    system: "System",
  },
  items: {
    dashboard: "Dashboard",
    inbox: "Inbox",
    inquiries: "Inquiries",
    orders: "Orders",
    customers: "Customers",
    serviceQueue: "Service queue",
    flightDesk: "Flight desk",
    season: "Season",
    schedule: "Schedule",
    departures: "Departures",
    calendar: "Calendar",
    documents: "Documents",
    complaints: "Complaints",
    suppliers: "Suppliers",
    serviceCatalog: "Service catalog",
    templates: "Templates",
    invoices: "Invoices",
    payments: "Payments & margin",
    vouchers: "Vouchers",
    destinations: "Destinations",
    guides: "Guides",
    destinationTeams: "Contacts & teams",
    trips: "Trips",
    tripOrder: "Trip order",
    upgrades: "Upgrades",
    inspirations: "Inspirations",
    faq: "FAQ",
    jobOffers: "Job offers",
    holidays: "Holidays and breaks",
    podcastEpisodes: "Podcasts",
    blog: "Blog",
    contentPages: "Pages",
    reviews: "Reviews",
    googleReviews: "Google reviews",
    quiz: "Quiz",
    homepage: "Homepage",
    promoBar: "Promo bar",
    media: "Media",
    newsletterStudio: "NL Studio",
    automations: "Automations",
    journeys: "Journeys",
    analytics: "Analytics",
    wiki: "Wiki",
    countryKb: "Country KB",
    auditLog: "Audit log",
    users: "Users",
    integrations: "Integrations",
  },
};
